import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import Map from './map';
import Navbar from './navbar.js';
import maplibregl from 'maplibre-gl';
//import 'maplibre-gl/dist/maplibre-gl.css';
import { markers } from './clustermarkers.js';
import DatePicker from './DatePicker.js';
import './App.css';
import FilterPanel from './FilterPanel';
import './FiltersAndDate.css';
import './ControlPanel.css';
import Modal from 'react-modal';
import ErrorBoundary from './ErrorBoundary';
import introVideo from './introVideo.mp4';
import About from './About';
import Instructions from './Instructions';
import Preview from './Preview.js';
import MarkerDetails from './MarkerDetails';
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";


const filterMarkers = (markers, selectedFilters) => {
  return markers.filter((marker) =>
    Object.keys(selectedFilters).every((category) =>
      selectedFilters[category]?.length === 0 || // If no filter in this category, pass
      selectedFilters[category].some((filter) =>
        marker[category]?.includes(filter)
      )
    )
  );
};

function App() {
  const [showIntroPage, setShowIntroPage] = useState(true);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [selectedMarker, setSelectedMarker] = React.useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date("1800-01-01"),
    endDate: new Date("2200-01-01"),
  });
  const [filteredMarkers, setFilteredMarkers] = useState(markers);
  const [resultsCount, setResultsCount] = useState(markers.length);
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const mapRef = useRef(null);
  const popupRef = useRef(null);

  const handleMapLoad = (mapInstance) => {
    mapRef.current = mapInstance;
  };

  const handleSelectedMarkerChange = (marker) => {
    setSelectedMarker(marker);
    console.log("clicked marker: ", marker);
  };
  

  const [filters, setFilters] = useState({
    producer: [],
    event: [],
    theme: [],
    videoType: [],
    actors:[],
    avquality: [],
    viewCount: [],
    videoLength: [],
    hashtag: [],
  });

  const handleApplyClick = (startDate, endDate) => {
    if (startDate && endDate) {
      applyFilters({ startDate, endDate, filters });
      setSelectedDateRange({ startDate, endDate });
    }
  };

/*  const handleDateRangeSelect = (startDate, endDate) => {
    if (startDate && endDate) {
      setSelectedDateRange({ startDate, endDate });
      applyFilters({ startDate, endDate, filters });
      console.log('selecteddaterange: ', selectedDateRange);
    }
  };
*/  

  const handleFilterChange = (filter) => {
    setFilters(filter);
    applyFilters({ startDate: selectedDateRange?.startDate, endDate: selectedDateRange?.endDate, filters: filter });
  };

  const applyFilters = ({ startDate, endDate, filters }) => {
    try {
      console.log(startDate, endDate);
  
      // Filter based on date range first
      let filteredMarkers = markers.filter(marker => {
        const withinDateRange =
          (startDate === null && endDate === null) || (
              new Date(marker.pubDate).getTime() >= new Date(startDate).getTime() &&
              new Date(marker.pubDate).getTime() <= new Date(endDate).getTime()
          );
        return withinDateRange;
      });
  
      // Apply the rest of the filters
      filteredMarkers = filterMarkers(filteredMarkers, filters);
      
      setResultsCount(filteredMarkers.length);
      setFilteredMarkers(filteredMarkers);
      setShowPreview(true);
      setSelectedMarker(null);
    } catch (error) {
      console.error('Error in applyFilters:', error);
    }
  };  

  const handleHashtagClick = (hashtag) => {
    // Check if the hashtag already exists
    if (!filters.hashtag.includes(hashtag)) {
        const newFilters = { ...filters, hashtag: [...filters.hashtag, hashtag] };
        setFilters(newFilters);
        applyFilters({ startDate: selectedDateRange?.startDate, endDate: selectedDateRange?.endDate, filters: newFilters });
    }
  };  

  const handleAboutClick = () => {
    setShowAboutModal(true);
  };

  /*
  const handleModalClose = () => {
    setShowAboutModal(false);
  };

  const handleCloseAboutModal = () => {
    setShowAboutModal(false);
  };
  */

  // Using an object for multiple modal visibility states
  const [modalVisible, setModalVisible] = useState({
    about: false,
    instructions: false,
  });

  // A single function to handle opening modals
  const handleModalOpen = (modalName) => {
    setModalVisible({ ...modalVisible, [modalName]: true });
  };

  // A single function to handle closing modals
  const handleModalClose = (modalName) => {
    setModalVisible({ ...modalVisible, [modalName]: false });
  };

  const flyToMarker = (marker) => {
    if (mapRef.current) {
      mapRef.current.flyTo({
        center: [marker.longitude, marker.latitude],
        zoom: 14,
        essential: true,
        offset: [0, -window.innerHeight / 4], // Offset downwards
      });

      // Remove the old popup
      if (popupRef.current) {
        popupRef.current.remove();
      }

      // Create a popup and set the content to "This"
      const popup = new maplibregl.Popup({ offset: 25 })
        .setLngLat([marker.longitude, marker.latitude])
        .setHTML(`<p>${marker.title}</p>`)
        .addTo(mapRef.current); // Attach it to the map

      popupRef.current = popup;
    }
  };
  

  return (
    <div className="app-container">
      {showIntroPage ? (
        <div className="intro-page">
          <video className="bg-video" loop autoPlay muted>
            <source src={introVideo} type="video/mp4" />
          </video>
          <div className="intro-content">
            <h1 className="intro-title">Urban Video Archive</h1>
            <button className="intro-button" onClick={() => {setShowIntroPage(false); setShowPreview(true);}}>Start exploring!</button>
          </div>
        </div>
      ) : (
        <>
          <header className="app-header">
            <Navbar handleModalOpen={handleModalOpen} />
          </header>

          <div className="app-content">
            <div className="filters-and-date">
              <button onClick={() => { console.log("Button clicked"); setShowPreview(true); setSelectedMarker(null);}} className="results-count">{resultsCount} results found!</button>
              <DatePicker handleApplyClick={handleApplyClick} applyFilters={applyFilters} isMapLoaded={isMapLoaded} />
              <FilterPanel filters={filters} onApplyFilter={handleFilterChange} selectedHashtag={filters.hashtag} />
            </div>

            {showPreview && !selectedMarker && (
              <div className="marker-details">
                <Preview
                  markers={filteredMarkers}
                  onSelectMarker={(marker) => {
                    console.log('Clicked marker:', marker);
                    setSelectedMarker(marker);
                  }}
                  onClose={() => setShowPreview(false)}
                />
              </div>
            )}

            {selectedMarker && (
              <div className="marker-details">
                {selectedMarker !== null && (
                  <MarkerDetails
                    marker={selectedMarker}
                    onClose={() => setSelectedMarker(null)}
                    onBackToPreview={() => setShowPreview(true)}
                    onHashtagClick={handleHashtagClick}
                    showOnMap={flyToMarker}
                  />
                )}
              </div>
            )}
  
            <div className="map-container">
              <ErrorBoundary>
                {filteredMarkers.length > 0 && (
                  <Map
                    setIsMapLoaded={setIsMapLoaded}
                    markers={filteredMarkers}
                    className="app-map"
                    resultsCount={resultsCount}
                    isMapLoaded={isMapLoaded}
                    setShowPreview={setShowPreview}
                    onSelectedMarkerChange={handleSelectedMarkerChange}
                    onMapLoad={handleMapLoad}
                    flyToMarker={flyToMarker}
                  />
                )}
              </ErrorBoundary>
            </div>
          </div>
  
          {/* Modal for About */}
          <Modal
            isOpen={modalVisible.about}
            onRequestClose={() => handleModalClose('about')}
            className="Modal"
            overlayClassName="Overlay"
          >
            <About handleClose={() => handleModalClose('about')} />
          </Modal>

          {/* Modal for Instructions */}
          <Modal
            isOpen={modalVisible.instructions}
            onRequestClose={() => handleModalClose('instructions')}
            className="Modal"
            overlayClassName="Overlay"
          >
            <Instructions handleClose={() => handleModalClose('instructions')} />
          </Modal>
          
          <Router>
            <Routes>
              
              <Route path="/about" element={<About />} />
            </Routes>
          </Router>
          
        </>
      )}
    </div>
  );
  
}

export default App;

